/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RouterDto } from '../../models/router-dto';

export interface GetRouterById$Params {

/**
 * The id of the device to fetch
 */
  id: string;
}

export function getRouterById(http: HttpClient, rootUrl: string, params: GetRouterById$Params, context?: HttpContext): Observable<StrictHttpResponse<RouterDto>> {
  const rb = new RequestBuilder(rootUrl, getRouterById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RouterDto>;
    })
  );
}

getRouterById.PATH = '/routers/{id}';
